import http from "@/utils/http";
const prefixUrl = {
  detail: "/Index/detailSunMoon.html", // API-6
};
export default {
  query(params = {}) {
    return http.get(prefixUrl.detail, { params });
  },
};
